<markant-platform-modal-bridge
  *ngIf="level2Customer || level2CustomerWithOpenFurtherQualificationProcess"
>
  <markant-dialog
    *ngIf="level2Customer"
    fullwidth="false"
    critical="false"
    class="dialog p-with-line-breaks"
    [open]="level2Customer"
    [headTitle]="'catalog.overview.furtherQualification.headline' | transloco"
    (close)="closeDialog()"
  >
    <div>
      <p
        class="p-with-line-breaks"
        [innerHTML]="
          'catalog.overview.furtherQualification.subtitle' | transloco
        "
      ></p>
    </div>
    <div slot="footer" class="footer-buttons">
      <markant-button
        colorScheme="primary"
        variant="clear"
        data-markant-dialog-action="cancel"
      >
        {{ 'catalog.overview.furtherQualification.cancel' | transloco }}
      </markant-button>
      <markant-button
        colorScheme="primary"
        (click)="toFurtherQualificationForm()"
      >
        {{
          'catalog.overview.furtherQualification.completeProfile' | transloco
        }}
      </markant-button>
    </div>
  </markant-dialog>

  <markant-dialog
    *ngIf="level2CustomerWithOpenFurtherQualificationProcess"
    fullwidth="false"
    critical="false"
    class="dialog"
    [open]="level2CustomerWithOpenFurtherQualificationProcess"
    [headTitle]="
      'catalog.overview.furtherQualification.openStatus.headline' | transloco
    "
    (close)="closeDialog()"
  >
    <div>
      <p
        class="p-with-line-breaks"
        [innerHTML]="
          'catalog.overview.furtherQualification.openStatus.subtitle'
            | transloco
        "
      ></p>
    </div>
    <div slot="footer">
      <markant-button colorScheme="primary" data-markant-dialog-action="cancel">
        {{
          'catalog.overview.furtherQualification.openStatus.close' | transloco
        }}
      </markant-button>
    </div>
  </markant-dialog>
</markant-platform-modal-bridge>
